<template>
  <div id="page-wrap">
    <PageHeader></PageHeader>
    <Dashboard></Dashboard>
  </div>

</template>

<script>
import PageHeader from './PageHeader'
import Dashboard from './Dashboard'
export default {
  name: 'Home',
  data () {
    return {

    }
  },
  components: {
    PageHeader, Dashboard
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue